<template>
  <div style="margin: 20px">
    <div style="display: flex; justify-content: space-between; margin-bottom: 20px">
      <div style="color: #333; font-size: 20px; font-weight: bold">
        模型配置列表
      </div>
      <el-button type="primary" size="small" @click="editConfig(null)">新建模型配置</el-button>
    </div>
    <el-table :data="dataList" style="width: 100%">
      <el-table-column type="index" prop="index" label="序号" width="100px"></el-table-column>
      <el-table-column prop="model_name" label="模型名称"></el-table-column>
      <el-table-column prop="model_type" label="模型类型"></el-table-column>
      <el-table-column prop="model_platform" label="模型平台"></el-table-column>
      <el-table-column prop="deployment_platform" label="部署平台"></el-table-column>
      <el-table-column prop="version_code" label="版本代码"></el-table-column>
      <el-table-column prop="context_length" label="上下文长度限制"></el-table-column>
      <el-table-column prop="rpm_limit" label="RPM限制"></el-table-column>
      <el-table-column prop="tpm_limit" label="TPM限制"></el-table-column>
      <el-table-column prop="tpd_limit" label="TPD限制"></el-table-column>
      <el-table-column prop="concurrency_limit" label="并发限制"></el-table-column>
      <el-table-column prop="open_range" label="开放范围"></el-table-column>
      <el-table-column prop="" label="输入金额">
        <template slot-scope="scope">
          {{ scope.row.input_config.price + ' ' + scope.row.input_config.unit + ' / ' + scope.row.input_config.per_token +' M Token'   }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="输出金额">
        <template slot-scope="scope">
          {{ scope.row.out_config.price + ' ' +scope.row.out_config.unit + ' / ' + scope.row.out_config.per_token +' M Token'   }}
        </template>
      </el-table-column>
      <el-table-column prop="working_status" label="Work Status"></el-table-column>
      <el-table-column prop="" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="editConfig(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="doRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="showModelConfigDialog" :title="modelConfigInfo.id == '' ? '新增模型配置' : '编辑模型配置'">
      <div>
        <el-form :model="modelConfigInfo" :ruels="formRules" ref="form">
          <el-form-item label="模型名称" prop="model_name">
            <el-input v-model="modelConfigInfo.model_name" placeholder="请输入模型名称"></el-input>
          </el-form-item>
          <el-form-item label="对外展示名称" prop="display_name">
            <el-input v-model="modelConfigInfo.display_name" placeholder="请输入对外展示名称"></el-input>
          </el-form-item>
          <el-form-item label="模型类型" prop="model_type">
            <el-select v-model="modelConfigInfo.model_type">
              <el-option label="LLM" value="LLM"></el-option>
              <el-option label="Text2Image" value="Text2Image"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模型平台" prop="model_platform">
            <el-select v-model="modelConfigInfo.model_platform">
              <el-option label="MoonShot" value="MoonShot"></el-option>
              <el-option label="DeepSeek" value="DeepSeek"></el-option>
              <el-option label="OpenAI" value="OpenAI"></el-option>
              <el-option label="Azure" value="Azure"></el-option>
              <el-option label="Anthropic" value="Anthropic"></el-option>
              <el-option label="Google" value="Google"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="API账号" prop="api_account">
            <el-input v-model="modelConfigInfo.api_account" placeholder="请输入API账号"></el-input>
          </el-form-item>
          <el-form-item label="部署平台" prop="deployment_platform">
            <el-select v-model="modelConfigInfo.deployment_platform">
              <el-option label="Native" value="Native"></el-option>
              <el-option label="SiliconFlow" value="SiliconFlow"></el-option>
              <el-option label="In-House" value="In-House"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本代码" prop="version_code">
            <el-input v-model="modelConfigInfo.version_code" placeholder="请输入版本代码"></el-input>
          </el-form-item>
          <el-form-item label="上下文长度限制" prop="context_length">
            <el-input-number v-model="modelConfigInfo.context_length" :min="0" placeholder="请输入上下文长度限制"></el-input-number>
          </el-form-item>
          <el-form-item label="RPM限制" prop="rpm_limit">
            <el-input-number v-model="modelConfigInfo.rpm_limit" :min="0" placeholder="请输入RPM限制"></el-input-number>
          </el-form-item>
          <el-form-item label="TPM限制" prop="tpm_limit">
            <el-input-number v-model="modelConfigInfo.tpm_limit" :min="0" placeholder="请输入TPM限制"></el-input-number>
          </el-form-item>
          <el-form-item label="TPD限制" prop="tpd_limit">
            <el-input-number v-model="modelConfigInfo.tpd_limit" :min="0" placeholder="请输入TPD限制"></el-input-number>
          </el-form-item>
          <el-form-item label="并发限制" prop="concurrency_limit">
            <el-input-number v-model="modelConfigInfo.concurrency_limit" :min="0" placeholder="请输入并发限制"></el-input-number>
          </el-form-item>
          <el-form-item label="开放范围" prop="open_range">
            <el-select v-model="modelConfigInfo.open_range">
              <el-option label="中国" value="China"></el-option>
              <el-option label="国际" value="International"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="输入金额" prop="" style="display: flex;">
            <el-input-number v-model="modelConfigInfo.input_config.price" placeholder="请输入"></el-input-number>
            <el-select v-model="modelConfigInfo.input_config.unit" style="width: 100px;">
              <el-option label="USD" value="USD"></el-option>
              <el-option label="RMB" value="RMB"></el-option>
            </el-select> /
            <el-input-number v-model="modelConfigInfo.input_config.per_token" placeholder="请输入"></el-input-number>
            Million Token
          </el-form-item>
          <el-form-item label="输出金额" prop="" style="display: flex;">
            <el-input-number v-model="modelConfigInfo.out_config.price" placeholder="请输入"></el-input-number>
            <el-select v-model="modelConfigInfo.out_config.unit" style="width: 100px;">
              <el-option label="USD" value="USD"></el-option>
              <el-option label="RMB" value="RMB"></el-option>
            </el-select> /
            <el-input-number v-model="modelConfigInfo.out_config.per_token" placeholder="请输入"></el-input-number>
            Million Token
          </el-form-item>
          <el-form-item label="Work Status" prop="working_status">
            <el-select v-model="modelConfigInfo.working_status">
              <el-option label="未配置" value="未配置"></el-option>
              <el-option label="配置中" value="配置中"></el-option>
              <el-option label="配置完成" value="配置完成"></el-option>
              <el-option label="已上线" value="已上线"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="small" @click="saveConfig">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateAIModelConfig, getModels, postRequest, removeAIModelConfig } from "@/apis/lfAdmin";
export default {
  name: "index",
  data() {
    return {
      modelList: [],
      dataList: [
        'gpt-4o',
        'gpt-4o-mini',

      ],
      modelConfigInfo: {
        id: "",
        model_name: "",
        display_name: "",
        model_type: "",
        model_platform: "",
        api_account: "",
        deployment_platform: "",
        version_code: "",
        context_length: "",
        rpm_limit: "",
        tpm_limit: "",
        tpd_limit: "",
        concurrency_limit: "",
        open_range: "",
        input_config: {
          price: '',
          unit: '',
          per_token: ''
        },
        out_config: {
          price: '',
          unit: '',
          per_token: ''
        },
        working_status: "",
      },
      formRules: {
        model_name: [
          { required: true, message: "Please select", trigger: "blur" },
        ],
        display_name: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        model_type: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        model_platform: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        api_account: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        deployment_platform: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        version_code: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        context_length: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        rpm_limit: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        tpm_limit: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        tpd_limit: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        concurrency_limit: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        open_range: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        model_input_price: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        model_output_price: [
          { required: true, message: "Please input", trigger: "blur" },
        ],
        working_status: [
          { required: true, message: "Please select", trigger: "blur" },
        ],
      },
      showModelConfigDialog: false,
    };
  },
  mounted() {
    this.fetchData();
    this.requestModels();
  },
  methods: {
    requestModels() {
      // getModels().then((res) => {
      //   let result = res.data.data.data;
      //   result.forEach(item => {
      //     this.modelList.push(item.id)
      //   });
      // });
    },

    fetchData() {
      postRequest("getAllKnowitAIModelConfigs").then((res) => {
        this.dataList = res.data.data;
      });
    },
    doRemove(row) {
      this.$alert('你确定要删除此模型配置吗？', '提示', {
        callback: action => {
          if (action == 'confirm') {
            removeAIModelConfig(row._id.$id).then((res) => {
              this.$message.success('删除成功')
              this.fetchData()
            })
          }
        }
      })
    },
    saveConfig() {
      this.$refs["form"].validate((val) => {
        if (val) {
          updateAIModelConfig(this.modelConfigInfo).then((res) => {
            this.$message.success("更新成功");
            this.fetchData();
            this.showModelConfigDialog = false;
          });
        }
      });
    },
    editConfig(row) {
      if (row) {
        this.modelConfigInfo = {
          id: row._id.$id,
          model_name: row.model_name,
          display_name: row.display_name || "",
          model_type: row.model_type || "",
          model_platform: row.model_platform || "",
          api_account: row.api_account || "",
          deployment_platform: row.deployment_platform || "",
          version_code: row.version_code || "",
          context_length: row.context_length || "",
          rpm_limit: row.rpm_limit || "",
          tpm_limit: row.tpm_limit || "",
          tpd_limit: row.tpd_limit || "",
          concurrency_limit: row.concurrency_limit || "",
          open_range: row.open_range || "",
          input_config: row.input_config,
          out_config: row.out_config,
          working_status: row.working_status,
        };
      } else {
        this.modelConfigInfo = {
          id: "",
          model_name: "",
          display_name: "",
          model_type: "",
          model_platform: "",
          api_account: "",
          deployment_platform: "",
          version_code: "",
          context_length: "",
          rpm_limit: "",
          tpm_limit: "",
          tpd_limit: "",
          concurrency_limit: "",
          open_range: "",
          input_config: {
            price: '',
            unit: '',
            per_token: ''
          },
          out_config: {
            price: '',
            unit: '',
            per_token: ''
          },
          working_status: "",
        };
      }
      this.showModelConfigDialog = true;
    },
  },
};
</script>
